"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var Table_1 = __importDefault(require("@mui/material/Table"));
var TableCell_1 = require("@mui/material/TableCell");
var TableRow_1 = require("@mui/material/TableRow");
var StyledDetailTable = (0, styles_1.styled)(Table_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(TableRow_1.tableRowClasses.root, " td:first-of-type, th:first-of-type")] = {
            paddingLeft: theme.spacing(3)
        },
        _b[".".concat(TableRow_1.tableRowClasses.root, " td:last-of-type, th:last-of-type")] = {
            paddingRight: theme.spacing(2)
        },
        _b[".".concat(TableCell_1.tableCellClasses.root)] = {
            fontSize: '14px',
            letterSpacing: '0.15px',
            color: 'rgba(0,0,0, 0.87)',
        },
        _b[".".concat(TableCell_1.tableCellClasses.body)] = {
            borderBottom: 'none'
        },
        _b[".".concat(TableRow_1.tableRowClasses.root, " .MuiIconButton-root svg.MuiSvgIcon-root")] = {
            borderRadius: '0.8em',
            width: '1em',
            height: '1em',
            padding: '0.3em',
            color: 'rgba(0,0,0, 0.6)',
        },
        _b[".".concat(TableRow_1.tableRowClasses.root, " .MuiIconButton-root.Mui-disabled  svg.MuiSvgIcon-root")] = {
            color: 'rgba(0,0,0, 0.25)',
        },
        _b[".".concat(TableRow_1.tableRowClasses.root, ":hover .MuiIconButton-colorError svg.MuiSvgIcon-root")] = {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.error.main,
            border: '1px solid #eaeaea',
            width: '0.9em',
            height: '0.9em'
        },
        _b[".".concat(TableRow_1.tableRowClasses.root, ":hover .MuiIconButton-colorPrimary:not(.Mui-disabled) svg.MuiSvgIcon-root")] = {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.main,
            border: '1px solid #eaeaea',
            width: '0.9em',
            height: '0.9em'
        },
        _b[".".concat(TableCell_1.tableCellClasses.root, " .MuiButtonBase-root")] = {
            padding: '0 2px 0 0'
        },
        _b[".".concat(TableCell_1.tableCellClasses.head)] = {
            fontWeight: '600',
            fontSize: '14px',
            lineHeight: '24px',
            letterSpacing: '0.17px',
            color: 'rgba(0,0,0, 0.75)'
        },
        _b);
});
exports.default = StyledDetailTable;
